<template>
  <div class="addModel">
    <div class="addfrom">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="130px" labelPosition='left'>
        <el-row>
          <el-col :span="24">
            <el-form-item label="仓库：" prop="depotId">
              <el-select v-model="ruleForm.depotId" @change="changeDepot" clearable placeholder="请选择仓库">
                <el-option v-for="item in depotLst" :key="item.id" :label="item.depotName" :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="出库原因：" prop="fetchType">
              <el-select v-model="ruleForm.fetchType" @change="changeFetchType" clearable placeholder="请选择原因">
                <el-option v-for="item in fetchTypes" :key="item.fetchTypeId" :label="item.fetchTypeName" :value="item.fetchTypeId">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item label="仪器：" v-for="(item, index) in insId" :key="index">
              <el-select v-model="item.id" clearable placeholder="请选择仪器" filterable @visible-change="openOrdown" @change="((item,index) => changeValue(item,index))">
                <el-option v-for="item1 in freeInsLst"  :disabled="item1.disabled" :key="item1.id" :label="item1.instrumentName" :value="item1.id">
                  <span style="float: left">{{ item1.instrumentName }}</span>
                  <span style="float: right; color: #8492a6; font-size: 13px">{{ item1.serialNumber }}</span>
                </el-option>
              </el-select>
              <el-button v-waves type="danger" size="small" round @click="deleteIns(index,item)">删除</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class='footer'>
        <el-button v-waves class="mybtny" @click="submit">确定</el-button>
        <el-button v-waves class="mybtny" @click="addCheckCon">增加仪器</el-button>
        <el-button v-waves class="mybtnn" @click="cancel">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { getDepotInfo } from "@/api/depotApi";
import { getFreeLst } from "@/api/fetchApi";
export default {
  data() {
    return {
      ruleForm: {
        depotId: "",
        fetchType: "",
        insId: [],
      },
      insId: [],
      rules: {
        depotId: [{ required: true, message: "请选择仓库", trigger: "blur" }],
        fetchType: [
          { required: true, message: "请选择出库原因", trigger: "blur" },
        ],
      },
      depotLst: [],
      fetchTypes: [],
      freeInsLst: [],
    };
  },
  created() {
    this.userInfo = this.$store.state.user.userInfo;
    this.depostInfo();
    this.fetchTypes = [
      { fetchTypeId: 1, fetchTypeName: "借出" },
      { fetchTypeId: 2, fetchTypeName: "检定" },
      { fetchTypeId: 3, fetchTypeName: "维修" },
      { fetchTypeId: 4, fetchTypeName: "保养" },
      { fetchTypeId: 5, fetchTypeName: "其他" },
    ];
  },
  mounted() {

  },
  methods: {
    //获取仓库数据
    depostInfo() {
      let self = this;
      getDepotInfo({ deptId: this.userInfo.deptId }).then((res) => {
        if (res.code == "200") {
          self.depotLst = res.data;
        }
      });
    },
    //获取可取仪器
    getFreeLst(item) {
      let self = this;
      getFreeLst({ depotId: item }).then((res) => {
        if (res.code == "200") {
          self.freeInsLst = res.data.map(it =>{
            return {
              disabled:false,
              ...it
            }
          })
        }
      });
    },
    changeValue(data,index){
      console.log(data,'data')
     
      for (let index = 0; index < this.freeInsLst.length; index++) {
        const element = this.freeInsLst[index];
        if(element.id == data){
          element.disabled = true
        }else{
          element.disabled = false
        }
        
      }

    },
    openOrdown(state){
      if(state){
        for (let index = 0; index < this.freeInsLst.length; index++) {
        const item = this.freeInsLst[index];
         for (let i = 0; i < this.insId.length; i++) {
          const element = this.insId[i];
          if(item.id==element.id){
            item.disabled = true
          }
          
         }
         
      }
      }

    },
    submit() {
      if (!this.ruleForm.depotId) {
        this.$message({
          message: "请选择仓库",
          type: "warning",
        });
        return;
      }
      if (!this.ruleForm.fetchType) {
        this.$message({
          message: "请选择出库原因",
          type: "warning",
        });
        return;
      }
      if (this.insId.length == 0) {
        this.$message({
          message: "请选择仪器",
          type: "warning",
        });
        return;
      }
      let insLst = [];
      for (let i = 0; i < this.insId.length; i++) {
        if (!this.insId[i].id) {
          this.$message({
            message: "请选择仪器",
            type: "warning",
          });
          return;
        } else {
          insLst.push(this.insId[i].id);
        }
      }
      this.ruleForm.insId = insLst;
      this.$emit("submit", this.ruleForm, true);
    },
    cancel() {
      this.$emit("cancel");
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
    },
    handleChange(file, fileList) {
      this.files = fileList.slice(-1);
    },
    changeDepot(item) {
      this.getFreeLst(item);
    },
    changeFetchType(item){

    },
    addCheckCon() {
      this.insId.push({ id: "" });
    },
    deleteIns(index,data) {
      for (let i = 0; i < this.freeInsLst.length; i++) {
        const item = this.freeInsLst[i];
        if(item.id==data.id){
          item.disabled = false
        }
      }
      this.insId.splice(index, 1);
    },
  },
};
</script>

<style lang='less' scoped>
.addModel {
  .addfrom {
    margin: 0 30px;
    .topcontent {
      margin-bottom: 20px;
      .el-row {
        margin-bottom: 0;
        height: 40;
      }
      p {
        padding: 0 10px;
      }
    }
    .el-row {
      /deep/.el-form-item {
        margin-bottom: 10px;
      }
    }
  }
  .footer {
    text-align: center;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/fetch/components/addFetch.vue